import { render } from "./GenerateTableData.vue?vue&type=template&id=0f00cb3e&scoped=true&ts=true"
import script from "./GenerateTableData.vue?vue&type=script&lang=ts"
export * from "./GenerateTableData.vue?vue&type=script&lang=ts"

import "./GenerateTableData.vue?vue&type=style&index=0&id=0f00cb3e&scoped=true&lang=css"
import "./GenerateTableData.vue?vue&type=style&index=1&id=0f00cb3e&lang=css"

import exportComponent from "/data/landun/workspace/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0f00cb3e"]])

export default __exports__